import { useCallback, useMemo, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Box } from '@mui/material'
import MainNav from 'ui/components/MainNav'
import CookieBanner from 'ui/components/CookieBanner/CookieBanner'
import ErrorBoundary from 'ui/components/ErrorBoundary'
import { Alert } from 'ui/baseComponents'
import AdminLayoutContext from './AdminLayoutContext'
import AdminSidebar, { DEFAULT_SIDEBAR_WIDTH } from './AdminSidebar'

const AdminLayout = () => {
  const location = useLocation()
  const [mobileOpen, setMobileOpen] = useState(false)
  const [collapsed, setCollapsed] = useState(false)
  const [sidebarWidth, setSidebarWidth] = useState(DEFAULT_SIDEBAR_WIDTH)

  const toggleMobileSidebar = useCallback(() => {
    setMobileOpen((prev) => !prev)
  }, [])

  const contextValue = useMemo(
    () => ({ toggleMobileSidebar }),
    [toggleMobileSidebar],
  )

  return (
    <AdminLayoutContext.Provider value={contextValue}>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <MainNav />
        <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          <AdminSidebar
            mobileOpen={mobileOpen}
            onMobileClose={() => setMobileOpen(false)}
            collapsed={collapsed}
            onToggleCollapse={() => setCollapsed((prev) => !prev)}
            width={sidebarWidth}
            onWidthChange={setSidebarWidth}
          />
          <Box
            component="main"
            sx={{ flex: 1, overflow: 'auto', backgroundColor: '#f5f7fa' }}
          >
            <Box sx={{ p: 3 }}>
              <ErrorBoundary
                resetKey={location.pathname}
                fallback={
                  <Alert severity="error">
                    Something went wrong loading this section.
                  </Alert>
                }
              >
                <Outlet />
              </ErrorBoundary>
            </Box>
          </Box>
        </Box>
        <CookieBanner />
      </Box>
    </AdminLayoutContext.Provider>
  )
}

export default AdminLayout
